import { useQuery } from '@apollo/client'
import { CircularProgress } from '@mui/material'
import { makeStyles } from '@material-ui/core'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { GET_CORPORATE_EMPLOYEE_DETAILS } from 'src/services/individualService'

const RegistrationStatsSearch = ({ clientId, searchText, userType }) => {
  const classes = useStyles()
  const {
    loading: analyticsDataLoading,
    error: analyticsDataError,
    data: analyticsData,
  } = useQuery(GET_CORPORATE_EMPLOYEE_DETAILS(), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    variables: {
      clientId: clientId,
      userType: userType,
      search: searchText,
    },
  })

  if (analyticsDataLoading)
    return (
      <div className='loadingContainer'>
        <CircularProgress />
      </div>
    )
  if (analyticsDataError) {
    return (
      <div>
        <GraphQlErrors error={analyticsDataError} />
      </div>
    )
  }
  return (
    <div>
      <div className={classes.analyticsContainer}>
        {analyticsData?.getUserDetails?.usersDetails?.map((item) => {
          return (
            <div className={classes.personDetails} key={item?.employeeId}>
              {`${item?.userName} (${item?.employeeId})`}
            </div>
          )
        }) ?? '-'}
      </div>
    </div>
  )
}

export default RegistrationStatsSearch

const useStyles = makeStyles({
  analyticsContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '14px',
    padding: '10px 10px',
  },
  personDetails: {
    padding: '2px 0px 2px 35px',
    fontWeight: 'bold',
  },
})
